<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  loading: { type: Boolean, default: false },
  pending: { type: Array, default: () => [] },
});

const emit = defineEmits(['dismiss']);
const { t } = useI18n();

const dismiss = item => emit('dismiss', item);
</script>

<template>
  <div
    v-if="loading"
    class="mb-[15px] flex min-w-0 gap-[10px] overflow-hidden"
    data-test="sales-property-documents-loading"
    role="status"
    :aria-label="t('SALES_PROPERTY.DOCUMENTS.LOADING')"
  >
    <span
      class="h-[100px] w-[213px] max-w-[30%] shrink-0 animate-pulse rounded-lais-sm bg-lais-bg-soft"
      aria-hidden="true"
    />
    <span
      class="h-[100px] min-w-0 flex-1 max-w-[460px] animate-pulse rounded-lais-sm bg-lais-bg-soft"
      aria-hidden="true"
    />
  </div>

  <div
    v-if="pending.length"
    class="mb-[15px] grid gap-[15px]"
    data-test="sales-property-documents-pending"
  >
    <div v-for="item in pending" :key="item.key" class="min-w-0">
      <div
        v-if="!item.error"
        class="my-5 flex min-w-0 items-end gap-[10px] rounded-[10px] border-2 border-lais-border-soft bg-white p-5"
        data-test="sales-property-document-progress"
      >
        <span class="shrink-0 text-xl font-normal text-lais-text-muted">
          {{ t('SALES_PROPERTY.DOCUMENTS.UPLOADING') }}
        </span>
        <progress
          class="min-w-0 flex-1 accent-lais-primary"
          :value="item.progress"
          max="100"
          :aria-label="item.name"
          data-test="sales-property-document-progress-bar"
        />
      </div>

      <template v-else>
        <div class="flex min-w-0 items-center gap-0">
          <div
            class="flex h-14 min-w-0 flex-1 cursor-not-allowed items-center justify-between rounded-[10px] border-[3px] border-[#f9d2d2] bg-white px-[23px] py-4 text-red-500"
            data-test="sales-property-document-error-file"
          >
            <span class="truncate text-xl font-normal">
              {{ item.name }}
            </span>
            <span
              class="i-lucide-circle-alert size-5 shrink-0 text-lais-danger"
              aria-hidden="true"
            />
          </div>
          <button
            type="button"
            class="grid h-14 shrink-0 place-items-center rounded-[10px] bg-lais-danger px-[22px] py-[6px] text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:shadow-lais-focus"
            data-test="sales-property-document-dismiss-error"
            :aria-label="t('SALES_PROPERTY.DOCUMENTS.REMOVE')"
            :title="t('SALES_PROPERTY.DOCUMENTS.REMOVE')"
            @click="dismiss(item)"
          >
            <span class="i-lucide-x size-5" aria-hidden="true" />
          </button>
        </div>
        <p
          class="my-[10px] text-[0.8rem] font-bold text-lais-danger"
          data-test="sales-property-document-error-message"
        >
          {{ item.error }}
        </p>
      </template>
    </div>
  </div>
</template>
